import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/mov-dev.m2lab.ru/layouts/default.vue").then(m => m.default || m)),
  "default-old": defineAsyncComponent(() => import("/var/www/mov-dev.m2lab.ru/layouts/default_old.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/var/www/mov-dev.m2lab.ru/layouts/simple.vue").then(m => m.default || m))
}